import { render, staticRenderFns } from "./DsnVueTable.vue?vue&type=template&id=d38ad49a&"
import script from "./DsnVueTable.vue?vue&type=script&lang=js&"
export * from "./DsnVueTable.vue?vue&type=script&lang=js&"
import style0 from "./DsnVueTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports